
/**
 * 미디어 유형
 */
export type GetStreamingInfo200MediaInfoType = typeof GetStreamingInfo200MediaInfoType[keyof typeof GetStreamingInfo200MediaInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStreamingInfo200MediaInfoType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
  AUDIO: 'AUDIO',
  LINK: 'LINK',
} as const;
